import React from "react";
import "./SunraysFooter.css";
import Logo from "../Logo/SUNRAYF.png";

const SunraysFooter: React.FC = () => {
  return (
    <footer className="shivam-custom-footer1">
      <div className="shivam-footer-container">
        {/* ================= COMPANY ================= */}

        <div className="shivam-footer-col company">
          <img
            src={Logo}
            alt="Sunrays Logistics"
            className="shivam-footer-logo"
          />

          <p className="company-text">
            Sunrays Logistics is committed to delivering reliable, secure and
            time-sensitive logistics solutions across India and worldwide. We
            combine technology, speed and customer satisfaction to make every
            shipment hassle-free.
          </p>

          <div className="company-buttons">
            <a
              href="https://sunrayslogistics.in/abouts_page"
              className="footer-btn"
            >
              About Company
            </a>

            <a
              href="https://sunrayslogistics.in/contacts_page"
              className="footer-btn outline"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* ================= DIVISIONS ================= */}

        <div className="shivam-footer-col">
          <h4>Company</h4>

          <ul>
            <li>
              <a href="/">Home</a>
            </li>

            <li>
              <a href="/about">About Us</a>
            </li>

            <li>
              <a href="/services">Services</a>
            </li>

            <li>
              <a href="/network">Our Network</a>
            </li>

            <li>
              <a href="/career">Career</a>
            </li>
          </ul>
        </div>

        {/* ================= SERVICES ================= */}

        <div className="shivam-footer-col">
          <h4>Services</h4>

          <ul>
            <li>
              <a href="/road">Road Freight</a>
            </li>

            <li>
              <a href="/air">Air Freight</a>
            </li>

            <li>
              <a href="/ocean">Ocean Freight</a>
            </li>

            <li>
              <a href="/rail">Rail Freight</a>
            </li>

            <li>
              <a href="/express">Express Delivery</a>
            </li>
          </ul>
        </div>

        {/* ================= QUICK LINKS ================= */}

        <div className="shivam-footer-col">
          <h4>Quick Links</h4>

          <ul>
            <li>
              <a href="/tracking">Track Shipment</a>
            </li>

            <li>
              <a href="/quote">Request Quote</a>
            </li>

            <li>
              <a href="/support">Customer Support</a>
            </li>

            <li>
              <a href="/privacy">Privacy Policy</a>
            </li>

            <li>
              <a href="/terms">Terms & Conditions</a>
            </li>
          </ul>
        </div>

        {/* ================= CONTACT ================= */}

        <div className="shivam-footer-col">
          <h4>Get In Touch</h4>

          <div className="footer-contact">
            <p>
              <i className="fas fa-location-dot"></i>
              Royal Accord Co. , Op. Society, 5th Floor , R. No.513 , Opp. Jain
              Temple , Cigarette Co. Andheri (East), Mumbai - 400 099
            </p>

            <p>
              <i className="fas fa-phone"></i>

              <a href="tel:+8657988982">+8657988982</a>
            </p>

            <p>
              <i className="fas fa-envelope"></i>

              <a href="mailto:info.sunrayslogistics@gmail.com">
                info.sunrayslogistics@gmail.com
              </a>
            </p>
          </div>

          <div className="shivam-footer-social">
            <a href="#">
              <i className="fab fa-facebook-f"></i>
            </a>

            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>

            <a href="#">
              <i className="fab fa-linkedin-in"></i>
            </a>

            <a href="#">
              <i className="fab fa-youtube"></i>
            </a>

            <a href="https://wa.me/7304340500" target="_blank" rel="noreferrer">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>

      {/* ================= COPYRIGHT ================= */}

      <div className="shivam-footer-bottom">
        <p>© 2023 Sunrays Logistics. All Rights Reserved.</p>

        <span>
          Powered By{" "}
          <a href="https://www.neotechnet.com" target="_blank" rel="noreferrer">
            Neotech IT Services
          </a>
        </span>
      </div>
    </footer>
  );
};

export default SunraysFooter;
